import { ACTIONS } from 'actions/toast-msg';

const initialState = {
  message: null,
  ctaList: null,
  timeout: null,
  toastMetaData: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.HIDE_TOAST_MESSAGE:
      return {
        message: null,
        ctaList: null,
        timeout: null,
        toastMetaData: null,
      };
    case ACTIONS.SHOW_TOAST_MESSAGE: {
      const { message, ctaList, timeout, toastMetaData } = payload;

      return {
        message,
        ctaList,
        timeout,
        toastMetaData,
      };
    }
    default:
      return state;
  }
}
